import React from 'react';
import styled from 'styled-components';
import TwitterImage from './twitter.svg';

const shareUrl = (url, title) => {
  const encodedUrl = encodeURIComponent(url);
  const encodedMessage = encodeURIComponent(`${title} | AC ミハラ`);

  return `https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedMessage}`;
};

const ImageIcon = styled.img`
  height: 15px;
  width: 15px;
`;

export default ({url, title}) => (
  <div>
    <a href={shareUrl(url, title)} target="blank_" rel="noopener noreferrer">
      <ImageIcon src={TwitterImage} />
    </a>
  </div>
);
